import { useSelector } from 'react-redux';
import { ReactComponent as AddIcon } from '../../components/icons/add-icon.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as TwoPeople } from '../../components/icons/two-people.svg';
import { ReactComponent as UserOctagon } from '../../components/icons/user-octagon.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton';
import CustomInput from '../../components/components/custom_input/customInput';
import {setKeyword, setSearchValue} from "../../store/userTabSlice";
import apiService from "../../components/api_services/apiService";

// Akcje dla tabeli użytkowników
export const userActions = {
  deleteSelected: (selected) => {
    console.log('Usuń zaznaczonych użytkowników');

    apiService.deleteUsersByIdList(selected).then(r => console.log(r.data) )
      .catch(e => console.log(e.response.data.message));
    alert('User mark for deleting. Will be anonymized at midnight!');
    // Logika usuwania użytkowników na podstawie zaznaczonych ID
  },
  changeTab: (tabName, dispatch, setActiveUsersTab) => {
    console.log('Zmieniono zakładkę na:', tabName);
    dispatch(setActiveUsersTab(tabName));
  },
};

// Konfiguracja nagłówków tabeli
export const getHeaders = (sortBy, sortDirection, dispatch, setSorting, sortArrowColorActive, sortArrowColorInactive, rowsUsers, checkedItems) => [
  <input
  type="checkbox"
  checked={rowsUsers.every((row) => checkedItems.includes(row[1]))} // Sprawdzenie, czy wszystkie elementy są zaznaczone
  onChange={(e) => {
    const allIds = rowsUsers.map((row) => row[1]); // Pobierz ID wszystkich elementów
    if (e.target.checked) {
      // Dodaj wszystkie elementy do checkedItems
      dispatch({ type: 'users/setCheckedItems', payload: [...new Set([...checkedItems, ...allIds])] });
    } else {
      // Usuń wszystkie elementy z checkedItems
      dispatch({ type: 'users/setCheckedItems', payload: checkedItems.filter((id) => !allIds.includes(id)) });
    }
  }}
/>,
  'ID',
  <div className="table-columns-headers">
    <div>Nazwa użytkownika</div>
    <SortArrows
      upColor={sortBy === 'name' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'name' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'name') {
          dispatch(setSorting({ sortBy: 'name', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'name', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Email</div>
    <SortArrows
      upColor={sortBy === 'email' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'email' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'email') {
          dispatch(setSorting({ sortBy: 'email', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'email', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Telefon</div>
    <SortArrows
      upColor={sortBy === 'phoneNumber' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'phoneNumber' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'phoneNumber') {
          dispatch(setSorting({ sortBy: 'phoneNumber', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'phoneNumber', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Sporty</div>
    <SortArrows
      upColor={sortBy === 'skillsCounter' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'skillsCounter' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'skillsCounter') {
          dispatch(setSorting({ sortBy: 'skillsCounter', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'skillsCounter', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Treningi</div>
    <SortArrows
      upColor={sortBy === 'trainingsCounter' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'trainingsCounter' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'trainingsCounter') {
          dispatch(setSorting({ sortBy: 'trainingsCounter', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'trainingsCounter', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Rejestracja</div>
    <SortArrows
      upColor={sortBy === 'createdAt' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'createdAt' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'createdAt') {
          dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
    <div>Pakiet</div>
    <SortArrows
      upColor={sortBy === 'accountPlan' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'accountPlan' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'accountPlan') {
          dispatch(setSorting({ sortBy: 'accountPlan', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'accountPlan', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
          }
        }
      }}
    />
  </div>,
  <div className="table-columns-headers">
  <div>Akcje</div>
</div>,
];

// Szerokości kolumn
export const headerWidths = ['42px', '50px', '2fr', '3fr', '130px', '100px', '110px', '125px', '90px', '100px'];

// Konfiguracja zakładek
export const tabsConfig = (activeUsersTab, dispatch, setActiveUsersTab) => [
  {
    icon: TwoPeople,
    name: 'Użytkownicy',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Użytkownicy' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Użytkownicy', dispatch, setActiveUsersTab),
    toggleActive: true,
  },
  {
    icon: UserOctagon,
    name: 'Administratorzy',
    hoverClass: 'hover-effect',
    activeClass: activeUsersTab === 'Administratorzy' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Administratorzy', dispatch, setActiveUsersTab),
    toggleActive: true,
  },
];

// Konfiguracja przycisków
export const buttonsConfig = (toggleAddModal) =>[
  {
    icon: AddIcon,
    name: 'Dodaj użytkownika',
    baseClass: 'custom-button-black',
    hoverClass: 'hover-effect',
    activeClass: '',
    onClick: () => {
      toggleAddModal();
    },
    toggleActive: false,
  },
];

export const empty = [];

// Konfiguracja lewej strony
export const leftSideConfig = (checkedItems) => [
  {
    component: CustomButton,
    props: {
      icon: Trash,
      name: 'Usuń zaznaczone',
      baseClass: 'custom-button-white',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => userActions.deleteSelected(checkedItems), // Przekaż tutaj zaznaczone ID użytkowników
      toggleActive: false,
    },
  },
];

// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Wyszukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValue(value)); // Ustaw wartość wyszukiwania w stanie lokalnym
        if (value.length >= 3 ) {
          dispatch(setKeyword(value)); // Aktualizuj stan w Reduxie
        } else {
          dispatch(setKeyword(null)); // Resetuj stan w Reduxie, jeśli mniej niż 3 znaki
        }
      }
      }
  },
];